module.exports = __webpack_public_path__ + "static/media/check.e28689d2.svg";